import React from 'react';
import {
  AppBar,
  IconButton,
  Toolbar,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import { LoginAvatar, MenuButton } from '../controls';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  content: {
    display: 'flex',
    // flex: 1,
    height: '100%',
    overflow: 'hidden',
  },
  flex: {
    flex: 1,
  },
  toolbar: {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
  },
  menuButton: {
    marginRight: 10,
  },
  noShadow: {
    boxShadow: 'none',
  },
}));

export default function Container({
  showBack,
  title,
  children,
  extraButtonsRender,
  noShadow,
}) {
  const history = useHistory();
  const classes = useStyles();

  function handleBackClick() {
    history.goBack();
  }

  return (
    <div className={classes.root}>
      <AppBar
        className={noShadow ? classes.noShadow : undefined}
        position="static"
      >
        <Toolbar variant="dense" className={classes.toolbar}>
          {showBack ? (
            <IconButton
              color="inherit"
              className={classes.menuButton}
              onClick={handleBackClick}
            >
              <ArrowBackIcon />
            </IconButton>
          ) : (
            <MenuButton color="inherit" className={classes.menuButton} />
          )}
          <Typography variant="h6" color="inherit">
            {title}
          </Typography>
          <div className={classes.flex}></div>
          {extraButtonsRender && extraButtonsRender()}
          <LoginAvatar />
        </Toolbar>
      </AppBar>
      <div className={classes.content}>{children}</div>
    </div>
  );
}
